<template lang="html">


  <div class="wrapper margin-menu">

    <section class="intro column-center -mide">
      <h2>Emprendimiento</h2>
      <h1>Madrid Innovation Driven Ecosystem</h1>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.lafundacion')">La Fundación</router-link>
        <router-link :to="$t('enlaces.mide')">Mide</router-link>
      </nav>
    </section>

    <main>

      <div class="container">

        <h2 class="title-intro">
          <img src="/static/img/logo-mide.png" alt="Logo mide">
        </h2>

        <p class="texto-intro">
          MIDE es una asociación independiente sin ánimo de lucro que actúa como plataforma de colaboración para todos los agentes que intervienen en el ecosistema de emprendimiento e innovación:
          Corporaciones, Emprendedores, Inversores, Universidades y Administraciones Públicas.
        </p>

      </div>


      <div class="objetivo row-start container">
        <h2 class="big-title">Objetivo</h2>
        <div class="destacado">
          <h4>Nuestro objetivo</h4>
          <p><strong>El fin de MIDE es apoyar la generación de empresas de alto potencial de crecimiento</strong> y sumar los esfuerzos de innovación a todos los niveles en la región de Madrid.</p>
        </div>
        <img src="/static/img/imagen-nuestro-objetivo.png">
      </div>


      <div class="white-box">
        <div class="container row-start como-conectamos">
          <h2 class="big-title">Cómo</h2>
          <div class="imagen">
            <img src="/static/img/grafico-como-conectamos.png" alt="Gráfico MIDE">
          </div>
          <div class="texto">
            <h2>Conectamos a los principales protagonistas del ecosistema</h2>
            <p><strong>MIDE tiene como objetivo convertirse en un conector con todas las entidades: un espacio para la búsqueda de sinergias y colaboraciones.</strong></p>
            <p>Queremos unificar esfuerzos para mejorar la posición competitiva global de la Comunidad de Madrid y el IMPACTO generado en términos de innovación y emprendimiento.</p>
          </div>
        </div>
      </div>


      <div class="white-box">
        <div class="container row-start porque-madrid">
          <h2 class="big-title">Madrid</h2>
          <h3 class="title-intro">
            ¿Por qué <strong>Madrid</strong>?
          </h3>
        </div>
        <div class="red-border-box -mapa-madrid">
          <img src="/static/img/mapa-madrid.png" alt="mapa de madrid" class="mapa-madrid">
          <div class="contenedor-tips-madrid row-center ais">
            <div class="column-center">
              <div class="contenedor-imagen">
                <img src="/static/img/tip-madrid-1.svg" alt="imagen tip madrid">
              </div>
              <p><strong>Región de las grandes corporaciones Españolas</strong></p>
            </div>
            <div class="column-center">
              <div class="contenedor-imagen">
                <img src="/static/img/tip-madrid-2.svg" alt="imagen tip madrid">
              </div>
              <p><strong>Posición estratégica e infraestructura de movilidad.</strong></p>
            </div>
            <div class="column-center">
              <div class="contenedor-imagen">
                <img src="/static/img/tip-madrid-3.svg" alt="imagen tip madrid">
              </div>
              <p><strong>Impuestos ventajosos.</strong></p>
            </div>
            <div class="column-center">
              <div class="contenedor-imagen">
                <img src="/static/img/tip-madrid-4.svg" alt="imagen tip madrid">
              </div>
              <p><strong>Calidad de vida.</strong></p>
            </div>
          </div>
        </div>

      </div>


      <div class="contenedor-slider slider-dicen-de-nosotros container">
        <h3 class="title-intro">
          Dicen de nosotros
        </h3>
        <slick
          ref="slick"
          :options="slickOptions">
          <div class="slide -dicen-de-nosotros">
            <div class="slide-wrapper container row-start">
              <div class="contenedor-imagen">
                <img src="/static/img/dicen-de-nosotros-imagen.svg" alt="imagen dicen de nostros">
              </div>
              <div class="contenedor-texto">
                <h2>Europa Press</h2>
                <p>La plataforma colaborativa Madrid Innovation Driven Ecosystem (MIDE) impulsará el emprendimiento y la innovación en la Comunidad de Madrid, en el marco de un programa impulsado por el Massachussets Institute of Technology (MIT).</p>
                <!-- <a href="" class="btn with-border">Ver artículo</a> -->
              </div>
            </div>
          </div>
          <!-- <div class="slide -dicen-de-nosotros">
            <div class="slide-wrapper container row-start">
              <div class="contenedor-imagen">
                <img src="/static/img/dicen-de-nosotros-imagen.svg" alt="imagen dicen de nostros">
              </div>
              <div class="contenedor-texto">
                <h2>Europa Press</h2>
                <p>La plataforma colaborativa Madrid Innovation Driven Ecosystem (MIDE) impulsará el emprendimiento y la innovación en la Comunidad de Madrid, en el marco de un programa impulsado por el Massachussets Institute of Technology (MIT).</p>
                <a href="" class="btn with-border">Ver artículo</a>
              </div>
            </div>
          </div> -->
        </slick>
      </div>


      <div class="banner-fondo-madrid">
        <p>Madrid es una Comunidad Autónoma emprendedora.  Creemos que puede consolidarse como un punto de referencia a nivel global en innovación y emprendimiento.</p>
        <a href="https://www.mide.global/" target="_blank" class="btn with-border">Ir a la web</a>
      </div>



    </main>

  </div>

</template>

<script lang="js">


import Slick from 'vue-slick';
  
  
  export default {
    name: 'mide',
    components: { Slick },
    data() {
        return {
            slickOptions: {
                slidesToShow: 1
            },
        };
    },
  }
    
  </script>


<style lang="scss">
  
  </style>


// WEBPACK FOOTER //
// src/components/views/mide.vue